module.exports = __webpack_public_path__ + "static/img/mkp-s9.39eea69.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mkp-s9.png
// module id = 338
// module chunks = 6